<template>
	<div>
		<el-table class="qcTable" :data="getUserlist" v-loading="loading">
			<el-table-column prop="Name" label="专家姓名" width="100"></el-table-column>
			<el-table-column prop="LoginId" label="手机号">
				<template slot-scope="scope">
					<span v-if="scope.row.LoginId == ' '">—</span>
					<span v-else>{{scope.row.LoginId}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="ExpertFromType" label="专家来源">
				<template slot-scope="scope">
					<span v-show="scope.row.ExpertFromType == 0">未知</span>
					<span v-show="scope.row.ExpertFromType == 1">专委会</span>
					<span v-show="scope.row.ExpertFromType == 2">集团外</span>
					<span v-show="scope.row.ExpertFromType == 3">集团内</span>
				</template>
			</el-table-column>
			<el-table-column prop="ExpertLevelType" label="专家分组">
				<template slot-scope="scope">
					<span v-if="scope.row.ExpertLevelType == 0">—</span>
					<span v-else>{{scope.row.ExpertLevelType}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="ExpertMajor" label="专家专业">
				<template slot-scope="scope">
					<span v-show="scope.row.ExpertMajor == 0">未知</span>
					<span v-show="scope.row.ExpertMajor == 1">超声</span>
					<span v-show="scope.row.ExpertMajor == 2">放射</span>
					<span v-show="scope.row.ExpertMajor == 3">核医学</span>
				</template>
			</el-table-column>
			<el-table-column prop="ModalityTypes" label="擅长设备">
				<template slot-scope="scope">
					<span v-if="scope.row.ModalityTypes == null||scope.row.ModalityTypes == ''">—</span>
					<span v-else>{{scope.row.ModalityTypes}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="BodyParts" label="擅长部位">
				<template slot-scope="scope">
					<span v-if="scope.row.BodyParts == null||scope.row.BodyParts == ''">—</span>
					<span v-else>{{scope.row.BodyParts}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="Title" label="专家职称">
				<template slot-scope="scope">
					<span v-if="scope.row.Title == null||scope.row.Title == ''">—</span>
					<span v-else>{{scope.row.Title}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="Enable" label="状态">
				<template slot-scope="scope">
					<span v-show="scope.row.Enable == 1">启用</span>
					<span v-show="scope.row.Enable == 0">禁用</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<span class="table-task-btn detail" @click="showClick(scope.row)">编辑</span>
					<span class="table-task-btn delete" @click="delterClick(scope.row)">删除</span>
				</template>

			</el-table-column>

		</el-table>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		computed: {
			...Vuex.mapState('managerUser', ['getUserlist', 'ExpertInfoDeleteArr', 'userParameter', 'expertJobCountList', 'loading'])
		},

		methods: {
			...Vuex.mapMutations('managerUser', ['setSplitScreen', 'setexpertInfoUpdateArr', 'setLoading']),
			...Vuex.mapActions('managerUser', ['ExpertInfoDelete']),
			//编辑
			showClick(arr) {
				this.setexpertInfoUpdateArr(arr);
				this.$router.push("/home/specialist/newSpecialistDetailsedit")
			},
			// //删除
			delterClick(arr) {
				this.ExpertInfoDeleteArr.ExpertGuid = arr.ExpertGuid;
				this.$confirm('是否确定删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.ExpertInfoDelete();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			}

		}

	}
</script>
